module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    class: {
      'wrapper--overlay': _vm.$route.meta.showModal
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showEpisode && _vm.showWebsite),
      expression: "!showEpisode && showWebsite"
    }],
    staticClass: "home"
  }, [_c('logo'), _vm._v(" "), _c('div', {
    staticClass: "bg",
    class: {
      'is-blurred': _vm.$route.meta.showModal
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "skyline-right pl"
  }), _vm._v(" "), _c('div', {
    staticClass: "skyline-left pl"
  }), _vm._v(" "), _c('div', {
    staticClass: "clouds-bg pl"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud cloud--left-top pl"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud cloud--left_bottom pl"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud cloud--right_bottom pl"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud cloud--right-top pl"
  }), _vm._v(" "), _c('div', {
    ref: "building",
    staticClass: "building",
    attrs: {
      "id": "building"
    }
  }, [_vm._l((_vm.randomWindowVideos), function(video, index) {
    return _c('window-video', {
      key: index,
      attrs: {
        "data": video
      }
    })
  }), _vm._v(" "), _c('png-sequence', {
    attrs: {
      "image": 'sequence-boterham-min.png',
      "height": 437,
      "width": 400,
      "frames": 39,
      "left": 722,
      "top": 332
    }
  }), _vm._v(" "), _c('png-sequence', {
    attrs: {
      "image": 'sequence-smoke.png',
      "height": 323,
      "width": 200,
      "frames": 50,
      "left": 1087,
      "top": 412
    }
  }), _vm._v(" "), _c('png-sequence', {
    attrs: {
      "image": 'sequence-neon-min.png',
      "height": 285,
      "width": 289,
      "frames": 43,
      "left": 785,
      "top": 5637
    }
  }), _vm._v(" "), _c('vlieg', {
    attrs: {
      "imageRight": 'sprite-vlieg-right.png',
      "imageLeft": 'sprite-vlieg-left.png',
      "height": 60,
      "width": 60,
      "frames": 8,
      "audio": _vm.sound
    }
  }), _vm._v(" "), _c('div', {
    ref: "buildingImage",
    staticClass: "building-image"
  }, [_c('img', {
    staticClass: "building-image__skeleton",
    attrs: {
      "src": _vm.urlSkeleton,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "building-image__top",
    attrs: {
      "src": _vm.urlTop,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "building-image__bottom",
    attrs: {
      "src": _vm.urlBottom,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bushes bushes--before"
  }), _vm._v(" "), _c('div', {
    staticClass: "bushes bushes--after"
  }), _vm._v(" "), _c('div', {
    staticClass: "light-shed glow-01"
  }), _vm._v(" "), _c('div', {
    staticClass: "light-lightbulb flicker"
  }), _vm._v(" "), _c('div', {
    staticClass: "light-blur light-blur--1 glow-01"
  }), _vm._v(" "), _c('div', {
    staticClass: "light-blur light-blur--2 glow-01"
  }), _vm._v(" "), _c('div', {
    staticClass: "light-blur light-blur--3 glow-01"
  }), _vm._v(" "), _c('div', {
    staticClass: "light-blur light-blur--4 glow-01"
  }), _vm._v(" "), _c('div', {
    staticClass: "light-blur light-blur--5 glow-01"
  }), _vm._v(" "), _c('div', {
    staticClass: "light-blur light-blur--6 glow-01"
  }), _vm._v(" "), _c('div', {
    staticClass: "light-blur light-blur--7 glow-01"
  }), _vm._v(" "), _c('div', {
    staticClass: "light-blur light-blur--8 glow-01"
  }), _vm._v(" "), _c('button', {
    staticClass: "codeslot",
    attrs: {
      "aria-label": "Open de aflevering van vandaag"
    },
    on: {
      "click": function($event) {
        _vm.openEpisode($event)
      }
    }
  }), _vm._v(" "), (!_vm.closed) ? _c('button', {
    staticClass: "door",
    attrs: {
      "aria-label": "Open de aflevering via de deur"
    },
    on: {
      "click": function($event) {
        _vm.openEpisode($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer s0",
    attrs: {
      "id": "trigger1"
    }
  }), _vm._v(" "), _c('div', {
    ref: "trigger2",
    staticClass: "spacer s0",
    attrs: {
      "id": "trigger2"
    }
  })], 2)]), _vm._v(" "), (_vm.lastFiveEpisodes.length > 0) ? _c('router-link', {
    staticClass: "episodes-button",
    class: {
      'episodes-button--hide': _vm.$route.meta.showModal
    },
    attrs: {
      "to": "/afleveringen"
    }
  }, [_vm._v("speel meer afleveringen")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "podcast-button",
    class: {
      'podcast-button--hide': _vm.$route.meta.showModal
    },
    attrs: {
      "to": "/podcast"
    }
  }, [_vm._v("luister naar de podcast")]), _vm._v(" "), _c('router-link', {
    staticClass: "info-link",
    class: {
      'info-link--hide': _vm.$route.meta.showModal
    },
    attrs: {
      "to": "/info"
    }
  }, [_vm._v("informatie")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skyline-bg pl"
  }, [_c('div', {
    staticClass: "skyline-bg__cloud"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18ec48d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/website/Home.vue
// module id = 702
// module chunks = 64